import {
  DEFAULT_VIEWPORT_WALLSIZE,
  DEFAULT_TOUCH_POINT_WIDTH,
  DEFAULT_TOUCH_POINT_START_COLUMN
} from '../../../../../store/cabinetVisualizer/selectors';
import { getPxInInches, inchesToPxs } from '../../../../../utils/wall-size-utils';

const DEFAULT_WIDTH = DEFAULT_VIEWPORT_WALLSIZE.Columns;

export const zoomIncrement = 0.1;
export const mobileZoomOffset = 0.20;
export const defaultZoom = 1;

export const mobileBreakpoint = 500;
export const isMobileVisualizer = (width) => width <= mobileBreakpoint;

export const getOccupiedWidth = (products) => {
  if (!products || products.length === 0) {
    return 0;
  }
  const minColumn = Math.min(...products.map((cabinet) => cabinet.Origin.Column));
  const maxColumn = Math.max(...products.map((cabinet) => cabinet.Origin.Column + cabinet.Origin.Width));

  const occupiedWidth = maxColumn - minColumn;
  return occupiedWidth;
};

export const handleAutoZoom = (width, products, direction, enableTouchPointsOnBothSides) => {
  if (!products || products.length === 0) {
    return defaultZoom;
  }
  const occupiedWidth = getOccupiedWidth(products);
  const pxInInches = getPxInInches(width, DEFAULT_WIDTH);
  const touchPointWidthInPx = inchesToPxs(DEFAULT_TOUCH_POINT_WIDTH, pxInInches);

  const maxWidth = DEFAULT_VIEWPORT_WALLSIZE.Columns;
  const widthInPx = inchesToPxs(maxWidth, pxInInches);
  const totalWidthInInches = !enableTouchPointsOnBothSides
    ? occupiedWidth + DEFAULT_TOUCH_POINT_WIDTH + DEFAULT_TOUCH_POINT_START_COLUMN
    : occupiedWidth + (DEFAULT_TOUCH_POINT_WIDTH + DEFAULT_TOUCH_POINT_START_COLUMN) * 2;

  const totalWidthInPx = inchesToPxs(totalWidthInInches, pxInInches);

  let scale = defaultZoom;
  if (products && products.length > 0
    && totalWidthInPx > widthInPx) {
    scale = (widthInPx / totalWidthInPx) * defaultZoom;
  }

  if (isMobileVisualizer(width) && totalWidthInPx + touchPointWidthInPx <= width && scale === defaultZoom) {
    return defaultZoom + mobileZoomOffset;
  }
  return scale;
};
